import gql from 'graphql-tag';

export const addDirectory = gql`

mutation addDirectory($dirObj: directories_insert_input!) {
  insert_directories_one(object: $dirObj) {
    id
  }
}

`;

export const
  addJobProfiles = gql`
mutation addjob_profiles($jobProfile: [job_profiles_insert_input!] !) {
  insert_job_profiles(objects: $jobProfile){
    affected_rows
    
  }
}
`;
export const addDirectoryProf = gql`

mutation addDirectory($professinalObj: directories_insert_input!) {
  insert_directories_one(object: $professinalObj) {
    id
  }
}

`;

export const getDicectoryCategories = gql`

query getDicectoryCategories {
    directory_categories{
    id
    name
  }
}

`;

export const getDirectoryCategory = gql`
query getDirectoryCategoryId($name: String!) {
  directory_categories(where: {name: {_eq: $name}}) {
    id
    name
  }
}
`;

export const getProfileJobUpdate = gql`

query getProfileJobUpdate ($dental_supplier_id:uuid){
  jobs(where: {dental_supplier_id: {_eq: $dental_supplier_id}}) {
    city,
    location
    description
    title
    company_name
    current_company
    experience
    skills
   
  }
}

`;

export const getUeserProfDirectory = gql`

subscription getUeserProfDirectory($id: uuid!){
  directories(where:{dental_professional_id:{_eq:$id}}) {
    id
    description
    name
    phone
    email
    banner_image
    profile_image
    abn_acn
    company_name
    description
    type
    address
    profession_type
    directory_category_id
    working_at
    education
    university_school
    hobbies
    alt_phone
    profession
    latitude
    longitude
    designation
    dental_professional{
    profile_image
    name
    }
    dental_supplier{
    logo
    name
    }
    dental_practice{
    logo
    name
    }
    directory_documents{
      name
      attachment
      
    }
    directory_locations{
      id
      media_name
      media_link
      status
      
    }
      
      directory_services{
        id
        name
        image
        description
      }
      directory_achievements{
        id
        title
        attachments
      }

      directory_certifications{
        id
        title
        attachments
      }


      directory_appointments{
        id
      }
      directory_team_members{
        id
        name
        specialization
        image
        phone
        email
        subrub
        state
      }

      directory_gallery_posts{
        id
        image
        before_image
        after_image
        banner_image
        profile_image
        logo
        before_and_after
      }
      
      directory_testimonials{
        id
        profile_image
        name
        message
        msg_pic
      }

      directory_faqs{
        id
        question
        answer
      }
    
  }
}

`;

export const getUeserSupDirectory = gql`

subscription getUeserSupDirectory($id: uuid!){
  directories(where:{dental_supplier_id:{_eq:$id}}) {
    id
    description
    name
    type
    abn_acn
    community_status
    community_id
    company_name
    profession_type
    directory_category_id
    email
    phone
    address
    latitude
    longitude
    alt_phone
    banner_image 
    logo
  
    directory_documents{
      name
      attachment
      
    }
      directory_locations{
        id
        media_name
        media_link
        status
        week_name
        clinic_time
      }
      
      directory_services{
        id
        name
        image
        description
      }

      directory_certifications{
        id
        title
        attachments
      }

      directory_achievements{
        id
        title
        attachments
      }
      directory_appointments{
        id
      }
      directory_team_members(where:{show_in_our_team:{_eq:"true"}}){
        id
        name
        specialization
        image
        phone
        email
        subrub
        state
        location
      }

      directory_gallery_posts{
        id
        image
        before_image
        after_image
        banner_image
        profile_image
        logo
        before_and_after
      }
      
      directory_testimonials{
        id
        profile_image
        name
        message
        msg_pic
        role
      }

      directory_faqs{
        id
        question
        answer
      }
      dental_supplier{
        business_name
      }
  }
}

`;

export const getUeserPracDirectory = gql`

subscription getUeserPracDirectory($id: uuid!){
  directories(where:{dental_practice_id:{_eq:$id}}) {
    id
    description
    name
    email
    phone
    address
    latitude
    longitude
    alt_phone
    type
    abn_acn
    company_name
    profession_type
    directory_category_id
    logo
    banner_image
    dental_practice{
    id
    business_name
    } 
    directory_documents{
      name
      attachment
      
    }
    directory_locations{
      id
      media_name
      media_link
      status
      week_name
      clinic_time
    }
      
      directory_services{
        id
        name
        image
        description
      }

      directory_certifications{
        id
        title
        attachments
      }

      directory_achievements{
        id
        title
        attachments
      }
      directory_appointments{
        id
      }
      directory_team_members(where:{show_in_our_team:{_eq:"true"}}){
        id
        name
        specialization
        image
        phone
        email
        subrub
        state
      }

      directory_gallery_posts{
        id
        image
        before_image
        after_image
        banner_image
        profile_image
        logo
        before_and_after
      }
      
      directory_testimonials{
        id
        profile_image
        name
        message
        msg_pic
      }

      directory_faqs{
        id
        question
        answer
      }
    
  }
}

`;

export const updateBasicInfo = gql`

mutation updateBasicInfo($id: uuid!, $updateInfo: directories_set_input!) {
  update_directories(where:{id:{_eq: $id}},_set: $updateInfo) {
   affected_rows
    
  }
}

`;

export const updateBasicInfoProf = gql`

mutation updateBasicInfoProf($id: uuid!, $professinalUpdateObj: directories_set_input!) {
  update_directories(where:{id:{_eq: $id}},_set: $professinalUpdateObj) {
   affected_rows
    
  }
}

`;

export const getPractice = gql`

query getPractice($id: uuid!){
  clients_by_pk(id:$id) {
    id
    name
    payload
  }
}

`;

export const getDirCatsByPk = gql`

subscription getDirCatsByPk($id: uuid!){
  directory_categories_by_pk(id:$id) {
    id
    name
  }
}

`;

export const getSupplier = gql`

subscription getSupplier($id: uuid!){
  dental_suppliers_by_pk(id:$id) {
    id
    abn_number
    profession_type
    business_name
  }
}

`;

export const getJobProfilesByProfessionalId = gql`
  query getJobProfilesByProfessional {
    job_profiles(order_by: { created_at: desc }) {
      id
      created_at
      updated_at
      skills
      jobexperiences
      upload_resume
      job_location
      job_designation
      current_company
      current_ctc
      dental_professional_id
      post_anonymously
      about_yourself
      location
    }
  }
`;

export const getBasicInfo = gql`

subscription getBasicInfo($id: uuid!){
  directories_by_pk(id:$id) {
    id
    dental_practice_id
    company_name
    address
    pincode
    directory_category_id
    description
    tags
    banner_image
    logo
    type
    email
    name
    phone
    alt_phone
    profession_type
    abn_acn
    latitude
    longitude
  }
}

`;


export const getBasicInfoProf = gql`

subscription getBasicInfoProf($id: uuid!){
  directories_by_pk(id:$id) {
    id
    special_interests
    certifications
    university_school
    hobbies
    education
    working_at
    directory_category_id
    profession_type
    name
    phone
    email
    awards
    designation
    profile_image
    banner_image
    alt_phone
    address
    latitude
    longitude
    description
    type
  }
}

`;


export const supplierData = gql`
query getSupplier($id: uuid!){
    dental_suppliers_by_pk(id:$id){
    id
    email
    name
    phone
    business_name
    community_status
    community_id
    logo
    profile_image
    abn_number
    profession_type
    directory_category_id
    address
    directories{
    logo
    banner_image
    }

  }
}
`;

export const practiceData = gql`
query getPractice($id: uuid!){
    dental_practices_by_pk(id:$id){
        id
        email
        name
        phone
        business_name
        logo
        abn_number
        profession_type
        directory_category_id
        address
  }
}
`;

export const professionalData = gql`
query getProfessional($id: uuid!){
    dental_professionals_by_pk(id:$id){
        id
        email
        name
        phone
        profession_type
        directory_category_id
        address
        profile_image
        gender
  }
}
`;

export const getJobProfiledata = gql`
  query GetJobProfileData {
    job_profiles (order_by: { created_at: desc }) {
      id
      created_at
      updated_at
      skills
      jobexperiences
      educations
      upload_resume
      job_designation
      current_company
      current_ctc
      dental_professional_id
      post_anonymously
	 admin_status
      profile_image
      full_name
		mobile_number
		email_address
    work_type
    profession_type
    location
    country
    city
    state
    cover_letter
    certificate
    radius
    abn_number
    availabilityOption  
    availabilityDate
    fromDate
    availabilityDay
    work_rights
    Year_of_experiance
    languages_spoken
    areas_expertise
    skills
    percentage
    salary_amount
    salary_type
    aphra_number
    willing_to_travel
    travel_distance
    about_yourself
    location
    availabilityType
    unavailabilityDate

    dental_professional	{
     id
     gender
    }
     jobhirings{
     id
     }
     
    }
  }
`;


export const getJobEditById = gql`
  query GetJobById($id: uuid!) {
    job_profiles_by_pk(id: $id) {
       post_anonymously
		jobexperiences
		profile_image
		skills
		upload_resume
		admin_status
		current_company
		current_ctc
		email_address
		full_name
		home_address
		job_designation
		job_location
		mobile_number
		created_at
		updated_at
    location
    city
    country
    state
    profession_type
    work_type
    radius
    work_rights
    about_yourself
    location
    Year_of_experiance
    languages_spoken
		areas_expertise
    willing_to_travel

    travel_distance
    aphra_number
    availabilityOption
    availabilityDate
    fromDate
    abn_number
		id
    educations
    percentage
    certificate
		cover_letter
    availabilityDay
    salary_amount
    salary_type
    availabilityType
    unavailabilityDate
    
    }
  }
`;
export const updateJobProfileMutation = gql`
    mutation update_job_profiles($id: uuid!, $postjobObj: job_profiles_set_input!) {
      update_job_profiles_by_pk(pk_columns: { id: $id }, _set: $postjobObj) {
        id
      }
    }
  `;
export const deleteJobFromListMutation = gql`
       mutation DeleteJob($id: uuid!) {
         delete_job_profiles_by_pk(id: $id) {
           id
         }
         delete_talent_enquiries(where: {talent_id: { _eq: $id }}){
         affected_rows
         }

         delete_talents_message(where: {talent_id: { _eq: $id }}){
         affected_rows
         }

       }
     `;
export const deleteJobHiringsByProfessionalIdMutation = gql`
  mutation DeleteJobHiringsByProfessionalId($dental_professional_id: uuid!) {
    delete_jobhirings(
      where: { dental_professional_id: { _eq: $dental_professional_id } }
    ) {
      affected_rows
    }
  }
`;

export const deleteJobTalentEnquiryMutation = gql`
  mutation DeleteJobtalentEnquiry($id: uuid!) {
    talent_enquiries(
      where: { talent_id: { _eq: $id } }
    ) {
      affected_rows
    }
  }
`;

export const getJobProfilesByUser = gql`
     query getJobProfilesByUser($dentalProfessionalId: String!) {
       job_profiles(where: {dental_professional_id: {_eq: $dentalProfessionalId}}) {
         id
       }
     }
     `;

export const getAllJobsRoleList = gql`
     query getAllJobsRoleName {
       jobs_role_list(order_by: { created_at: desc }) {
           id
           role_name
         }
      
     }
   `;

export const getAllJobsRoleMain = gql`
     query getAllJobsRoleList {
       jobs_role_list(order_by: { created_at: desc }) {
           id
           role_name
           created_at
           updated_at
           created_by
           created_by_user_id
         }
      
     }
   `;

export const getFilteredTalents = gql`
      query GetFilteredJobtalentProfiles($where: job_profiles_bool_exp!) {
    job_profiles(
      where: {
        _and: [
          { admin_status: { _eq: "APPROVE" } }
          $where
        ]
      }
    ) {
      id
      created_at
      updated_at
      skills
      jobexperiences
      upload_resume
      job_location
      job_designation
      current_company
      current_ctc
      dental_professional_id
      post_anonymously
      admin_status
      profile_image
      profession_type
      work_type
      state
      city
      full_name
      languages_spoken
      availabilityOption
      availabilityDate
      fromDate
      Year_of_experiance
      availabilityDay
      about_yourself
      location
    }
  }
`;

export const getJobProfileInfo = gql`subscription getprofilesData($id:uuid) {  
  job_profiles( where: {dental_professional_id:{_eq: $id}}) {
  post_anonymously
    id

 }}`




// Filter talentList


// export const getJobProfileList = gql`
//   query GetJobProfileData($professionalId: uuid!) {
//     job_profiles(
//       where: { dental_professional_id: { _eq: $professionalId } }
//       order_by: { created_at: desc }
//     ) {
//       id
//       created_at
//       updated_at
//       skills
//       jobexperiences
//       educations
//       upload_resume
//       job_designation
//       current_company
//       current_ctc
//       dental_professional_id
//       post_anonymously
// 	 admin_status
//    active_status
//       profile_image
//       full_name
// 		mobile_number
// 		email_address
//     work_type
//     profession_type
//     location
//     country
//     city
//     state
//     cover_letter
//     certificate
//     radius
//     abn_number
//     availabilityOption  
//     availabilityDate
//     fromDate
//     availabilityDay
//     work_rights
//     Year_of_experiance
//     languages_spoken
//     areas_expertise
//     skills
//     percentage
//     salary_amount
//     salary_type
//     aphra_number
//     willing_to_travel
//     travel_distance
//     about_yourself
//     location
//     availabilityType
//     unavailabilityDate

//     dental_professional	{
//      id
//      gender
//     }
//      jobhirings{
//      id
//      }

//     }
//   }
// `;


export const getJobProfileList = gql`
  query GetJobProfileData($professionalId: uuid!) {
    job_profiles(
      where: { dental_professional_id: { _eq: $professionalId } }
      order_by: { created_at: desc }
    ) {
      id
      created_at
      updated_at
      job_designation
      current_company
      dental_professional_id
      post_anonymously
      admin_status
      active_status
      profile_image
      full_name
      work_type
      profession_type
      availabilityOption
      availabilityDate
      fromDate
      availabilityDay
      availabilityType
      unavailabilityDate
      dental_professional {
        id
        gender
      }
      jobhirings {
        id
      }
    }
  }
`;


// Filter talentList

export const getTalentListMutation = gql`
  query getTalentList(
    $limit: Int
    $offset: Int
    $where: job_profiles_bool_exp
    $order_by: [job_profiles_order_by!]
  ) {
    job_profiles(
      where: $where
      order_by: $order_by
      limit: $limit
      offset: $offset
    ) {
       id
      created_at
      updated_at
      skills
      jobexperiences
      job_designation
      dental_professional_id
      post_anonymously
	 admin_status
      profile_image
      full_name
		mobile_number
    work_type
    profession_type
    location
    country
    city
    state
    availabilityOption  
    availabilityDate
    fromDate
    availabilityDay
    Year_of_experiance
    skills
    percentage
    about_yourself
    location
    availabilityType
    unavailabilityDate

    dental_professional	{
     id
     gender
    }
     jobhirings{
     id
     dental_supplier_id
     hiring_status
     dental_practice_id
     }
 
    }
  }
`;



export const updateTalentApproveStatusMutation = gql`
  mutation UpdateTalentStatus($id: uuid!, $status: String!) {
    update_job_profiles_by_pk(pk_columns: { id: $id }, _set: { active_status: $status }) {
      id
      active_status
    }
  }
`;




// // all related talent left side 
export const getRelatedTalentListMutation = gql`
 query getRelatedTalentListMutation($profession_type: String, $limit: Int!, $offset: Int!, $excludeId: uuid!) {
        job_profiles(
          where: { profession_type: { _eq: $profession_type }, id: { _neq: $excludeId },
          admin_status: { _eq: "APPROVE" }, active_status: { _eq: "ACTIVE" } }
          limit: $limit
          offset: $offset
          order_by: [{ created_at: desc }, { id: asc }]
        ) {
       id
      created_at
      skills
      jobexperiences
      educations
      upload_resume
      job_designation
      current_company
      dental_professional_id
      post_anonymously
      profile_image
      full_name
    work_type
    profession_type
    country
    city
    state
    cover_letter
    certificate
    fromDate
    Year_of_experiance
    skills
    about_yourself
    location

    dental_professional	{
     id
     gender
    }
     jobhirings{
     id
     dental_supplier_id
     }
    }
  }
`;

export const GET_TALENT_BY_ID = gql`
  query GET_TALENT_BY_ID($id: uuid!) {
    job_profiles(
     where: { id: { _eq: $id } }
    ) {
       id
      created_at
      updated_at
      skills
      jobexperiences
      job_designation
      dental_professional_id
      post_anonymously
	 admin_status
      profile_image
      full_name
		mobile_number
    work_type
    profession_type
    location
    country
    city
    state
    availabilityOption  
    availabilityDate
    fromDate
    availabilityDay
    Year_of_experiance
    skills
    percentage
    about_yourself
    location
    availabilityType
    unavailabilityDate

    dental_professional	{
     id
     gender
     name
    }
     jobhirings{
     id
     dental_supplier_id
     hiring_status
     }
 
    }
  }
`;
export const getTalentPreview = gql`
  query getTalentPreview($id: uuid!) {
    job_profiles(
     where: { id: { _eq: $id } }
    ) {
        id
      created_at
      updated_at
      skills
      jobexperiences
      educations
      upload_resume
      job_designation
      current_company
      current_ctc
      dental_professional_id
      post_anonymously
	 admin_status
   active_status
      profile_image
      full_name
		mobile_number
		email_address
    work_type
    profession_type
    location
    country
    city
    state
    cover_letter
    certificate
    radius
    abn_number
    availabilityOption  
    availabilityDate
    fromDate
    availabilityDay
    work_rights
    Year_of_experiance
    languages_spoken
    areas_expertise
    skills
    percentage
    salary_amount
    salary_type
    aphra_number
    willing_to_travel
    travel_distance
    about_yourself
    location
    availabilityType
    unavailabilityDate
    dental_professional	{
     id
     gender
     name
    }
     jobhirings{
     id
     dental_supplier_id
     hiring_status
     }
 
    }
  }
`;
